
<template>
  <div>
    <v-dialog
      v-model="dialog"
      scrollable  
      persistent
      max-width="800px"
      transition="dialog-transition"
    >
      <v-card style="border-radius: 6px">
        <v-card-title primary-title class="px-3 pt-2 pb-2">
          <v-row align='center' justify="space-between" class="pa-3">
            <v-col cols='12'>
              <v-row align='center' justify="space-between">
                <div class="headline mb-0 pa-4">Detalhes da consolidação</div>
                <v-btn class="ma-3" small rounded color="primary" @click="dialog=false">OK</v-btn>
              </v-row>
            </v-col>
            <v-col cols='6' v-if="!loading && one_consolidation">
              <div> Cliente </div>
              <div><b class="title"> {{one_consolidation.client_name}} </b></div>
            </v-col>
            <v-col cols='6' v-if="!loading && one_consolidation">
              <div> Período </div>
              <div> <b class="title"> 
                {{$moment(one_consolidation.start_date.split('T')[0]+'T12:00:00').format('DD/MM')}} 
                a {{$moment(one_consolidation.end_date.split('T')[0]+'T12:00:00').format('DD/MM')}} 
              </b></div>
            </v-col>
          </v-row>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-alert type="info" :value="true" v-if="loading">
            Carregando...
            <v-progress-linear color='white' :indeterminate="true"></v-progress-linear>
          </v-alert>

          <template v-if="!loading && one_consolidation">
            <div class="mt-5"></div>
            
            <v-row v-for="(item, key) in one_consolidation.json_attributes" :key="key+'key'"  >
              <template v-if="!['corrections', 'blocked_values'].includes(key)" >
                <v-col cols='12' class="mb-1 px-4 py-2 pt-3">
                  <v-row align="center">
                    <b :class="['title mr-2', success_icon_map[item.success].color+'--text']">{{label_maps[key]}}</b>
                    <v-icon small v-if="item.success != null" :color="success_icon_map[item.success].color" > 
                      {{success_icon_map[item.success].icon}} 
                    </v-icon>
                  </v-row>
                  <v-row v-if="item.calc" row wrap align='center' class="grey--text mt-2">
                    <div>
                      <span> <b>{{label_maps['calc']}}:</b> </span>
                      <span class="ml-2">{{item.calc}}</span>
                    </div>
                  </v-row>
                </v-col>
                <v-col cols='6' class="pl-4">

                  <div class="title font-weight-light mb-2">Consolidado</div>
                  <div v-for="(subitem, sub_key) in item" :key="sub_key+'key'" class="text-xs-left">
                    <div v-if="!['success', 'calc'].includes(sub_key)">
                      <span> <b>{{label_maps[sub_key]}}:</b> </span>
                      <span>{{Number(subitem).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) }}</span>
                    </div>
                  </div>
                </v-col>
                
                <!-- <v-col cols='6' v-if="item.success == false">
                  <div class="title font-weight-light mb-2">Correções</div>
                  <div>
                    <v-btn disabled color="warning" small @click="do_method()">corrigir</v-btn>
                  </div>
                </v-col>
                <v-col cols='12' class="mt-1">
                  <v-divider class="mt-1"></v-divider>
                </v-col> -->

              </template>
            </v-row>
          </template>
        </v-card-text>
        <v-card-actions class="justify-end pa-1" v-if="false">
          <v-btn small rounded color="primary" @click="dialog=false">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Api from '@/api/index'

export default {
  name: 'OneConsolidationDetails',
  props: {
    consolidation_id: {
      type: [Number, String],
    },
  },
  data() {
    return {
      key: null,
      dialog: true,
      
      loading: false,
      one_consolidation: null,

      label_maps: {
        corrections: 'Correções',

        blocked_values: 'Valores bloqueados',
        envelopes: 'Envelopes',
        deposits: 'Depósitos',
        bills: 'Boletos',
        pixes: 'Pix',

        checks_custody: "Cheques em custodia",
        custody: 'Em custódia',
        last_custody: 'Custódia anterior',
        confirmed: 'Confirmados',
        compensated: 'Compensados',

        payments: "Pagamentos",
        pay: 'Pagamentos executados',
        traces: 'Faturas baixadas',
        
        client_owes: "Quanto o cliente deve",
        owes: 'Quanto ele deve',
        last_owes: 'Quanto deve anterior',
        vrt_open: 'Faturas em aberto',
        bonus: 'Bônus',
        vrt_created: 'Faturas criadas',
        vrt_payed: 'Faturas pagas',
        
        trans_generation: "Geração de faturas",
        vrt: 'Faturas',
        order: 'Pedidos',
        reverse: 'Estornos',
        
        credit: "Credito do cliente",
        limit: 'Limite atual',
        original: 'Limitie original',

        success: 'Conforme',
        calc: 'Cálculo',

      },
      success_icon_map: {
        'false': {color: 'error', icon: 'mdi-thumb-down'},
        'true': {color: 'success', icon: 'mdi-thumb-up'},
      },

    }
  },
  methods: {
    getOneConsolidation() {
      this.loading = true
      Api.Client.showPeriodicConsolidation(this.consolidation_id).then(r=>r.data).then(d=>{
        d = d.data? d.data.attributes : d
        this.one_consolidation = {...d}
      }).finally(()=>{
        this.loading = false
      })
    },
  },
  mounted () {
    this.getOneConsolidation();
  },
  watch: {
    dialog(nv,ov) {
      if (nv){
      } else if (nv == false){
        this.$emit('close')
      }
    }
  },
}
</script>